import columns from '../../../../../../react-table/helpers/columns';

export default (data) => {
  const {
    TextColumn,
    DateTimeColumn,
    ColoredDateTimeColumn,
    NonZeroNumberColumn,
    ExternalDespatchLinkColumn,
  } = columns(data);

  return [
    {
      Header: '',
      columns: [
        new TextColumn('Sender', 'sender'),
        new ExternalDespatchLinkColumn(new TextColumn('Despatch ID', 'despatchId').withWidth(300)),
        new TextColumn('Measured', 'measured'),
        new TextColumn('On time', 'onTime'),
        new TextColumn('Transport mode', 'transportMode'),
        new ColoredDateTimeColumn('Transport departure date', 'transportDepartureDate', true, 'bg-header-blue'),
        new ColoredDateTimeColumn('Reference time', 'referenceTime', true, 'bg-header-blue'),
        new DateTimeColumn('On network (UTC)', 'onNetworkDate'),
        new DateTimeColumn('Preparation date', 'preparationDate'),
        new DateTimeColumn('Despatch closed', 'despatchClosedDate'),
        new TextColumn('Departure location', 'departureLocation'),
        new DateTimeColumn('Departure date', 'departureDate'),
        new TextColumn('Timezone', 'timezone'),
        new NonZeroNumberColumn('Receptacles', 'receptacles'),
      ],
    },
  ];
};
